// extracted by mini-css-extract-plugin
export default {"heading":"up-z","createAccount":"vp-z","disabled":"wp-z","copy":"xp-z","terms":"yp-z"};